import React from 'react';
import Typography from '@mui/material/Typography';

const PEPColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Name of Entity</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Entity Type</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Reference Number</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Source Information URL
        </Typography>
      </div>
    </>
  );
};

export default PEPColumns;
